import { COUNTRY_CODE } from '../config';
import { profile } from '../stores/storages/ProfileStorage';
import { clientInfo } from '../version';
import api from './api';
import config from './config';
import formatter from './formatter'

const GroupService = {
  createVote: async (groupId, title, enableAddVote, choice, options) => {
    const { token, username: msisdn } = profile;
    const timestamp = new Date().getTime();
    const clientType = 'desktop';
    const revision = clientInfo.revision;
    const expireAd = '';
    const anonymous = 0;
    const security = formatter.encrypt(`${msisdn}${groupId}${title}${anonymous}${enableAddVote}${expireAd}${choice}${options}${clientType}${revision}${token}${timestamp}`);
    const formData = new FormData();
    formData.append('msisdn', msisdn); //sđt người tạo
    formData.append('groupId', groupId); //groupId nhóm tạo vote
    formData.append('title', title); //tiêu đề vote
    formData.append('anonymous', anonymous);
    formData.append('enableAddVote', enableAddVote); // cho phép tạo thêm phương án: 1: cho phép, 0: không cho phép
    formData.append('expireAt', expireAd);
    formData.append('choice', choice); // cho phép chọn nhiều phương án: 2: cho phép, 1: không cho phép
    formData.append('options', options);// danh sách lựa chọn: ["phương án 1", "phương án 2"]
    formData.append('clientType', clientType);
    formData.append('revision', revision);
    formData.append('timestamp', timestamp);
    formData.append('security', security);

    const res = await api.request({
      method: config.endpoints.group.createVote.method,
      path: config.endpoints.group.createVote.path,
      host: config.host,
      data: formData,
      options: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        decrypt: false,
      },
    })
    return res;
  },
  vote: async (pollId, optionNewIds, optionOldIds) => {
    const { token, username: msisdn } = profile;
    const timestamp = new Date().getTime();
    const clientType = 'desktop'
    const revision = clientInfo.revision;
    const security = formatter.encrypt(`${msisdn}${pollId}${optionNewIds}${optionOldIds}${clientType}${revision}${token}${timestamp}`)
    const formData = new FormData()
    formData.append('msisdn', msisdn)
    formData.append('pollId', pollId)
    formData.append('optionNewIds', optionNewIds)
    formData.append('optionOldIds', optionOldIds)
    formData.append('clientType', clientType)
    formData.append('revision', revision)
    formData.append('timestamp', timestamp)
    formData.append('security', security)
    const res = await api.request({
      method: config.endpoints.group.vote.method,
      path: config.endpoints.group.vote.path,
      host: config.host,
      data: formData,
      options: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        decrypt: false,
      },
    })
    return res
  },
  addVote: async (pollId, groupId, options, newOptions) => {
    const { token, username: msisdn } = profile;
    const timestamp = new Date().getTime();
    const clientType = 'desktop'
    const revision = clientInfo.revision;
    const security = formatter.encrypt(`${msisdn}${pollId}${groupId}${options}${newOptions}${clientType}${revision}${token}${timestamp}`)
    const formData = new FormData();

    formData.append('msisdn', msisdn)
    formData.append('pollId', pollId)
    formData.append('groupId', groupId)
    formData.append('options', options)
    formData.append('newOptions', newOptions)
    formData.append('clientType', clientType)
    formData.append('revision', revision)
    formData.append('timestamp', timestamp)
    formData.append('security', security)

    const res = await api.request({
      method: config.endpoints.group.addVote.method,
      path: config.endpoints.group.addVote.path,
      host: config.host,
      data: formData,
      options: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        decrypt: false,
      },
    })
    return res
  },
  getVoteInfo: async (pollId) => {
    const { token, username: msisdn } = profile
    const timestamp = new Date().getTime();
    const clientType = 'desktop'
    const revision = clientInfo.revision;
    const security = formatter.encrypt(`${msisdn}${pollId}${clientType}${revision}${token}${timestamp}`)
    const data = {
      params: {
        msisdn,
        pollId,
        clientType,
        revision,
        timestamp,
        security,
      }
    }
    const res = await api.request({
      method: config.endpoints.group.getVoteInfo.method,
      path: config.endpoints.group.getVoteInfo.path,
      host: config.host,
      data,
      options: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        decrypt: false,
      },
    })
    return res
  },
  getListGroup: async () => {
    const { token, username: msisdn } = profile.authAPI;
    const timestamp = new Date().getTime()
    const security = formatter.encrypt(`${msisdn}${token}${timestamp}`)

    const data = {
      params: {
        msisdn,
        timestamp,
        security,
      },
    }
    const options = null

    const res = await api.request({
      method: config.endpoints.group.getListGroup.method,
      path: config.endpoints.group.getListGroup.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  getGroupDetail: async (groupId) => {
    const { token, username: msisdn } = profile.authAPI;
    const timestamp = new Date().getTime()
    const security = formatter.encrypt(`${msisdn}${groupId}${token}${timestamp}`)

    const data = {
      params: {
        msisdn,
        groupId,
        clientType: clientInfo.clientType,
        revision: clientInfo.revision,
        countryCode: COUNTRY_CODE,
        timestamp,
        security,
      },
    }
    const options = {
      decrypt: true
    }

    const res = await api.request({
      method: config.endpoints.group.getGroupDetail.method,
      path: config.endpoints.group.getGroupDetail.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  addPendingMember: async (groupId) => {
    const { token, username: msisdn } = profile.authAPI;
    const timestamp = new Date().getTime()
    const security = formatter.encrypt(`${msisdn}${groupId}${token}${timestamp}`)

    const data = new FormData()
    data.append('msisdn', msisdn)
    data.append('groupId', groupId)
    data.append('clientType', clientInfo.clientType)
    data.append('revision', clientInfo.revision)
    data.append('countryCode', COUNTRY_CODE)
    data.append('timestamp', timestamp)
    data.append('security', security)

    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      decrypt: false,
    }

    const res = await api.request({
      method: config.endpoints.group.addPendingMember.method,
      path: config.endpoints.group.addPendingMember.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  getPendingMember: async (groupId) => {
    const { token, username: msisdn } = profile.authAPI;
    const timestamp = new Date().getTime()
    const security = formatter.encrypt(`${msisdn}${groupId}${token}${timestamp}`)

    const data = {
      params: {
        msisdn,
        groupId,
        clientType: clientInfo.clientType,
        revision: clientInfo.revision,
        countryCode: COUNTRY_CODE,
        timestamp,
        security,
      },
    }
    const options = {
      decrypt: true
    }

    const res = await api.request({
      method: config.endpoints.group.getPendingMember.method,
      path: config.endpoints.group.getPendingMember.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  setPendingMemberAction: async (groupId, member, action) => {
    const { token, username: msisdn } = profile.authAPI;
    const timestamp = new Date().getTime()
    const security = formatter.encrypt(`${msisdn}${groupId}${member}${action}${token}${timestamp}`)

    const data = new FormData()
    data.append('msisdn', msisdn)
    data.append('groupId', groupId)
    data.append('member', member)
    data.append('action', action)
    data.append('clientType', clientInfo.clientType)
    data.append('revision', clientInfo.revision)
    data.append('countryCode', COUNTRY_CODE)
    data.append('timestamp', timestamp)
    data.append('security', security)

    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      decrypt: false,
    }

    const res = await api.request({
      method: config.endpoints.group.setPendingMemberAction.method,
      path: config.endpoints.group.setPendingMemberAction.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  setApprovals: async (groupId, enable) => {
    const { token, username: msisdn } = profile.authAPI;
    const timestamp = new Date().getTime()
    const security = formatter.encrypt(`${msisdn}${groupId}${enable}${token}${timestamp}`)

    const data = new FormData()
    data.append('msisdn', msisdn)
    data.append('groupId', groupId)
    data.append('enable', enable)
    data.append('clientType', clientInfo.clientType)
    data.append('revision', clientInfo.revision)
    data.append('countryCode', COUNTRY_CODE)
    data.append('timestamp', timestamp)
    data.append('security', security)

    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      decrypt: false,
    }

    const res = await api.request({
      method: config.endpoints.group.setApprovals.method,
      path: config.endpoints.group.setApprovals.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  setLinkState: async (groupId, state) => {
    const { token, username: msisdn } = profile.authAPI;
    const timestamp = new Date().getTime()
    const security = formatter.encrypt(`${msisdn}${groupId}${state}${token}${timestamp}`)

    const data = new FormData()
    data.append('msisdn', msisdn)
    data.append('groupId', groupId)
    data.append('state', state)
    data.append('clientType', clientInfo.clientType)
    data.append('revision', clientInfo.revision)
    data.append('countryCode', COUNTRY_CODE)
    data.append('timestamp', timestamp)
    data.append('security', security)

    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      decrypt: false,
    }

    const res = await api.request({
      method: config.endpoints.group.setLinkState.method,
      path: config.endpoints.group.setLinkState.path,
      host: config.host,
      data,
      options,
    })
    return res
  }
}

export default GroupService
